import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LanguageContext from '../contexts/LanguageContext';
import { getTranslation } from '../services/languageService';
import './Header.scss';

const Header = () => {
  const { language, setLanguage } = useContext(LanguageContext);
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'zh' : 'en';
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Close mobile menu when clicking on a link
  useEffect(() => {
    closeMenu();
  }, [location]);

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" onClick={closeMenu}>
            <img src="/images/logo_b.png" alt="Applied Intelli Logo" className="logo-image" />
            <span className="logo-text">{getTranslation('common.companyName', language)}</span>
          </Link>
          
          <button 
            className="menu-toggle"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          
          <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
            <ul className="nav-list">
              <li className="nav-item">
                <Link 
                  to="/" 
                  className={isActive('/') ? 'nav-link active' : 'nav-link'}
                  onClick={closeMenu}
                >
                  {getTranslation('navigation.home', language)}
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/about" 
                  className={isActive('/about') ? 'nav-link active' : 'nav-link'}
                  onClick={closeMenu}
                >
                  {getTranslation('navigation.about', language)}
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/services" 
                  className={isActive('/services') ? 'nav-link active' : 'nav-link'}
                  onClick={closeMenu}
                >
                  {getTranslation('navigation.services', language)}
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/portfolio" 
                  className={isActive('/portfolio') ? 'nav-link active' : 'nav-link'}
                  onClick={closeMenu}
                >
                  {getTranslation('navigation.portfolio', language)}
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/contact" 
                  className={isActive('/contact') ? 'nav-link active' : 'nav-link'}
                  onClick={closeMenu}
                >
                  {getTranslation('navigation.contact', language)}
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link 
                  to="/blog" 
                  className={isActive('/blog') ? 'nav-link active' : 'nav-link'}
                  onClick={closeMenu}
                >
                  {getTranslation('navigation.blog', language)}
                </Link>
              </li> */}
            </ul>
          </nav>
          
          <div className="header-actions">
            <button 
              className="language-toggle"
              onClick={toggleLanguage}
              aria-label={getTranslation('header.toggleLanguage', language)}
            >
              <span className="language-flag">
                {language === 'en' ? '🌐 中' : '🌐 EN'}
              </span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
